import {Component, OnInit, ViewEncapsulation} from '@angular/core';

import {ProductsArticleService} from './products-article.service';
import {ProductsCategoryService} from './products-category.service';
import {ProductsArticle} from './products-article';
import {ProductsCategory} from './products-category';
import {ProductsType} from './products-type';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AppComponent} from './app.component';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';
import {SuppliersService} from './suppliers.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {ActivatedRoute, Params} from '@angular/router';
import {LocationService} from './location.service';

import {DatePipe} from '@angular/common';
import {DateAdapter, NativeDateAdapter} from '@angular/material';

@Component({
    selector: 'products-list',
    styleUrls: ['./styles/products-list.component.css'],
    templateUrl: './templates/products-list.component.html',
    providers: [ProductsArticleService, ProductsCategoryService, AuthentificationService, SuppliersService, SortTable, LocationService],
    encapsulation: ViewEncapsulation.None
})

export class ProductsListComponent implements OnInit {

    position: string = 'below';

    lot_select: Array<any> = [
        {lot_value: '1', lot_answer: 'OUI'},
        {lot_value: '0', lot_answer: 'NON'}
    ];

    serial_select: Array<any> = [
        {serial_value: 'UNMANAGED_BY_SERIAL', serial_answer: 'NON GERE'},
        {serial_value: 'OUT', serial_answer: 'SORTIE'},
        {serial_value: 'IN_OUT', serial_answer: 'ENTREE/SORTIE'}
    ];

    issue_select: Array<any> = [
        {issue_value: 'FIFO', issue_answer: 'FIFO'},
        {issue_value: 'LIFO', issue_answer: 'LIFO'},
        {issue_value: 'CUMP', issue_answer: 'CUMP'}
    ];

    name = 'Products List';
    prod_list: ProductsArticle[];
    cat_list: ProductsCategory[];
    cat_list_search: ProductsCategory[];

    internal_code: string;
    reference_code: string;
    name_art: string;
    category: string = 'root';
    disabled_input = true;
    modif_title = 'RESUME';
    public list: string[];
    disabled_validate = true;
    type_list: ProductsType[];
    disabled_abstract = true;

    article: ProductsArticle = {
        id_article: 0,
        name: '',
        internal_code: '',
        reference_code: '',
        supplier_code: '',
        reference: '',
        type: '',
        category: '',
        conditioning: '',
        counting_unit: '',
        description: '',
        //ht_bying_price: 0,
        ht_selling_price: 0,
        supply_thershold: '',
        expiration_thershold: '',
        managed_by_lot: '',
        managed_by_serial: '',
        issue_mode: '',
        stocks: 0,
        stock_mini: 0,
        stock_maxi: 0,
        type_name: "",
        //id_supplier: 1
    };

    edit_article_form: FormGroup;
    showForm: boolean = true;
    modification_session: boolean = false;
    showconfirmation: boolean = false;
    pop_bt_function: string = "Supprimer";
    pop_infos: string = "Voulez-vous vraiment supprimer l' article";
    supplier_list: any;
    format_price_ht_bying_price: string = "0";
    format_price_ht_selling_price: string = "0";
    is_selling_price_sup: boolean = false;
    expiration_th_isnotNumber: boolean = false;
    sortedData: any = [];
    supplier_selected_list: any = [];
    supplier_empty: boolean = false;
    disable_select_list: boolean = false;
    disable_all_supplier_operation: boolean = false;
    supplier_selected: any;
    appro_min: number = 1;
    operation_bt = 'ajouter';
    indexofModif: number = -1;
    disable_bt: boolean = false;
    details_mode: boolean = false;
    dlc: any;

    constructor(
        private location_service: LocationService,
        private route: ActivatedRoute,
        private products_article_service: ProductsArticleService,
        private supplier_service: SuppliersService,
        private product_category_service: ProductsCategoryService,
        private app_component: AppComponent,
        private router: Router,
        private fb: FormBuilder,
        private authentification_service: AuthentificationService,
        private sort_table: SortTable,
        dateAdapter: DateAdapter<NativeDateAdapter>
    ) {
        dateAdapter.setLocale('fr-FR');

        this.createForm();
        this.CheckUserSession();
        this.app_component.valTest = '/products-list';
        this.app_component.GetParent();
    }

    ngOnInit(): void {
        this.Search();
        this.GetCategoriesList();
        this.GetTypesList();
        this.GetSupplierList();
    }

    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {
                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }
        return styles;
    }

    suppr_img_src: string = "../../img/ico_supp.png";

    ImageModifSrcFile(index: number) {
        let modif_img_src: string = "../../img/ico_modif.png";
        if (this.selected_tr === index) {
            modif_img_src = "../../img/ico_modif_blanc.png";
        }

        return modif_img_src;
    }

    ImageDeleteSrcFile(index: number) {
        let suppr_img_src: string = "../../img/ico_supp.png";
        if (this.selected_tr === index) {
            suppr_img_src = "../../img/ico_supp_blanc.png";
        }

        return suppr_img_src;
    }

    ColorIndex(index: number) {
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {
                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }
        return styles;
    }

    createForm() {
        this.edit_article_form = this.fb.group({
            name_ctl: ['', Validators.required],
            supplier_code_ctl: [''],
            type_ctl: ['', Validators.required],
            category_ctl: ['', Validators.required],
            conditioning_ctl: ['', Validators.required],
            counting_unit_ctl: ['', Validators.required],
            description_ctl: [''],
            ht_bying_price_ctl: ['0', Validators.required],
            ht_selling_price_ctl: ['0', Validators.required],
            supply_thershold_ctl: ['', Validators.required],
            issue_ctl: ['', Validators.required],
            serial_ctl: ['', Validators.required],
            lot_ctl: ['', Validators.required],
            //supplier_ctl: ['']
        });
    }

    GetArticlesList(): void {
        this.products_article_service.GetArticlesList().then(prod_list => {
            this.prod_list = prod_list;
        });
    }

    GetArticle_cb(): void {
        this.route.params.subscribe((params: Params) => {
            let id = params['id_article'];
            let indexofModif;
            if (id !== undefined) {
                //console.log(this.sortedData);
                indexofModif = this.sortedData.findIndex(article => article.id_article === id);
                this.article = this.sortedData[indexofModif];
                this.GetSupplierListByArticle(id);
                this.GetLocationListByArticle(id);

                //this.format_price_ht_bying_price = this.sortedData[indexofModif]['ht_bying_price'];
                this.format_price_ht_selling_price = this.sortedData[indexofModif]['ht_selling_price'];

                this.FormatPriceSelling(this.format_price_ht_selling_price);
                if (this.sortedData[indexofModif]['dlc'] !== "") {
                    this.dlc = new Date(this.sortedData[indexofModif]['dlc']);
                }
                if (this.sortedData[indexofModif]['status'] !== "FOR_SALE") {
                    this.for_sale = false;
                }else if(this.sortedData[indexofModif]['status'] === "FOR_SALE"){
                    this.for_sale = true;
                }

                for (let i = 0; i < this.sortedData.length; i++) {
                    console.log(this.sortedData[i].id_article);
                    if (this.sortedData[i].id_article === id) {
                        this.selected_tr = i;
                        this.modification_session = true;
                    }
                }

            }
        });
    }

    GetSupplierList(): void {
        this.supplier_service.GetSupplierList().then(result => {this.supplier_list = result['list']; if (result['list'] !== []) {this.supplier_selected = this.supplier_list[0];} });
    }

    AllArticles(): void {
        this.GetArticlesList();
    }

    GetCategoriesList(): void {
        this.product_category_service.GetCategoriesList().then(cat_list => this.cat_list = cat_list);

    }

    Search(): void {
        this.Reset();
        this.products_article_service.Search(this.internal_code, this.reference_code, this.name_art, this.category).then(
            prod_list => {
                //console.log(prod_list);
                this.prod_list = prod_list;
                this.sortedData = prod_list;
                this.sort_table.SetDataArray(prod_list, [
                    {value: "#", type: "number"}, {value: "internal_code", type: ""}, {value: "reference_code", type: ""}, {value: "name", type: ""}, {value: "cat", type: ""}
                ]);
                this.GetArticle_cb();
            });
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
    }

    GetTypesList(): void {
        this.products_article_service.GetTypesList().then(type_list => this.type_list = type_list);
    }
    
    for_sale = false;
    ArticleDetails(article: ProductsArticle): void {
        //console.log(article);
        this.modif_title = 'RESUME';
        this.modification_session = true;

        this.article = article;
        this.format_price_ht_selling_price = this.article.ht_selling_price.toString();

        this.disabled_input = true;
        this.disabled_validate = true;

        this.edit_article_form.disable();
        this.article.issue_mode = article.issue_mode;
        this.article.description = article.description;
        this.disabled_abstract = false;
        this.details_mode = true;

        this.format_price_ht_selling_price = article.ht_selling_price.toString();;

        this.FormatPriceSelling(this.format_price_ht_selling_price);

        this.GetSupplierListByArticle(article.id_article);
        this.GetLocationListByArticle(article.id_article);

        this.dlc = new Date(this.article['dlc']);
       // console.log(this.article);
        if(this.article['status'] === 'FOR_SALE'){
             this.for_sale = true;
             console.log(this.for_sale);
        }else{
            this.for_sale = false;
        }
       
    }

    GetSupplierListByArticle(id_article: number): void {
        this.supplier_service.GetSupplierListByArticle(id_article).then(result => {
            this.supplier_selected_list = [];
            for (let i = 0; i < result['list'].length; i++) {
                this.supplier_selected_list.push({supplier_object: result['list'][i], appro_min: parseInt(result['list'][i]['minimum_supply'])});
            }
            this.appro_min = result['list'][0]['minimum_supply'];
            this.supplier_selected = this.supplier_selected_list[0].supplier_object;
        });
    }

    location_selected_list: Array<any> = [];
    location_selected: any;
    GetLocationListByArticle(id_article: number): void {
        this.location_service.GetLocationListByArticle(id_article).then(result => {
            this.location_selected_list = [];
            for (let i = 0; i < result['list'].length; i++) {
                this.location_selected_list.push({location: result['list'][i]['location'], capacity: parseInt(result['list'][i]['capacity'])});
            }
            this.appro_min = result['list'][0]['maximum_capacity'];
            this.location_selected = this.location_selected_list[0].location_object;

        });
    }

    IssueStockRedirection(): void {
        this.router.navigate(['issue-stock_2', {id: this.article.id_article}]);
    }

    ReceipStockRedirection(): void {
        this.router.navigate(['receipt-stock_2', {id: this.article.id_article}]);
    }

    AbstractRedirection(): void {
        this.router.navigate(['products-abstract', {id: this.article.id_article, stocks: this.article.stocks}]);
    }

    Init(): void {
        this.article.id_article = 0,
            this.article.name = '',
            this.article.internal_code = '',
            this.article.reference_code = '',
            this.article.supplier_code = '',
            this.article.reference = '',
            this.article.type = '1',
            this.article.category = '1',
            this.article.conditioning = '',
            this.article.counting_unit = '',
            this.article.description = '',
            //this.article.ht_bying_price = 0,
            this.article.ht_selling_price = 0,
            this.article.supply_thershold = '',
            this.article.expiration_thershold = '',
            this.article.managed_by_lot = '',
            this.article.managed_by_serial = '',
            this.article.issue_mode = '',
            this.article.stocks = 0,
            this.article.type_name = ""
    }

    ModifyProduct(product: ProductsArticle): void {
        this.router.navigate(['product-modification', {
            id_article: product.id_article
        }]);
    }

    DeleteArticle(): void {
        this.products_article_service.DeleteArticle(this.article).then(prod_list => {this.prod_list = prod_list['list']; this.sortedData = prod_list; this.sortedData = prod_list; this.sort_table.SetDataArray(prod_list, [{value: "internal_code", type: ""}, {value: "reference_code", type: ""}, {value: "name", type: ""}, {value: "cat", type: ""}])});
    }

    ArchiveArticle(): void {
        this.products_article_service.ArchiveArticle(this.article.id_article).then(prod_list => {this.prod_list = prod_list; this.sortedData = prod_list; this.sort_table.SetDataArray(prod_list, [{value: "internal_code", type: ""}, {value: "reference_code", type: ""}, {value: "name", type: ""}, {value: "cat", type: ""}])});
    }

    DialogCancel(): void {
        this.showconfirmation = false;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    DialogConfirm(product: ProductsArticle): void {
        this.article = product;
        this.products_article_service.VerifyMovement(this.article).then(result => {
            this.showconfirmation = true;
            this.app_component.hide_wrapper(this.showconfirmation);

            if (result['result'] === 'OK') {
                //Supprimer
                this.pop_bt_function = "Supprimer";
                this.pop_infos = "Voulez-vous vraiment supprimer l' article";
            } else {
                this.pop_bt_function = "Archiver";
                this.pop_infos = "Ne peut être supprimer, voulez vous archiver";
            }
        });
    }

    BtPopFunction(): void {
        if (this.pop_bt_function === "Archiver") {
            this.ArchiveArticle();
        } else {
            this.DeleteArticle();
        }
        this.Reset();
    }

    ExpirationThershold(): void {
        if (isNaN(Number(this.article.supply_thershold))) {
            this.expiration_th_isnotNumber = true;
        } else {
            this.expiration_th_isnotNumber = false;
        }
    }

    Clean(str: string): string {
        var space = String.fromCharCode(160);
        var res_1 = String(str).replace('&nbsp;', ' ');
        var res_2 = String(res_1).replace(new RegExp(space, 'gi'), ' ');
        return res_2;
    }

    CleanFormatPrice(str_price: string): number {
        var str_price = this.Clean(str_price);
        var no_space = str_price.split(' ');
        return parseInt(no_space.join(''));
    }

    FormatPrice(price: string): string {
        let format_price = "";
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            if (!isNaN(Number(clean_price))) {
                format_price = Math.round(clean_price).toLocaleString();// + ' Ar';
            }
        }
        return format_price;
    }

    FormatPriceSelling(price: string): void {
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            this.article.ht_selling_price = clean_price;
            if (!isNaN(Number(clean_price))) {
                this.format_price_ht_selling_price = Math.round(clean_price).toLocaleString();// + ' Ar';
            } else {
                this.format_price_ht_selling_price = "0";
                this.article.ht_selling_price = 0;
            }
        } else {
            this.format_price_ht_selling_price = "0";
            this.article.ht_selling_price = 0;
        }
    }

    Reset(): void {
        this.edit_article_form.reset();
        this.showForm = false;

        setTimeout(() => {
            this.edit_article_form.reset();
            this.modification_session = false;
            this.showconfirmation = false;
            this.disabled_abstract = true;
            this.app_component.hide_wrapper(this.showconfirmation);
            this.article.stocks = 0;
            this.modif_title = 'RESUME';
            this.pop_bt_function = "Supprimer";
            this.pop_infos = "Voulez-vous vraiment supprimer l' article";
            this.details_mode = false;

            this.createForm();
            this.showForm = true;
        });
    }

    ButtonOperation(): void {
        if (this.operation_bt === "ajouter") {
            this.AddSupplier();
        } else {
            this.MofidySupplierApproMin();
        }
    }

    ModifyBt(supplier: any): void {
        if (!this.details_mode) {
            this.operation_bt = "valider";
            this.supplier_selected = supplier.supplier_object;
            this.appro_min = supplier.appro_min;
            this.indexofModif = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === this.supplier_selected.id_supplier);
            this.disable_select_list = true;
            this.disable_all_supplier_operation = false;
            this.disable_bt = false;
        }
    }

    SupprBt(supplier: any): void {

        if (!this.details_mode) {
            this.supplier_selected = supplier.supplier_object;
            var index = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === this.supplier_selected.id_supplier);
            if (index > -1) {
                this.supplier_selected_list.splice(index, 1);
            }

            if (this.supplier_selected_list.length == this.supplier_list.length) {
                this.disable_all_supplier_operation = true;
            } else {
                this.disable_all_supplier_operation = false;
            }

            this.disable_bt = false;
            this.indexofModif = -1;
        }
    }

    SetStyle(value: any) {
        let styles = {
            'color': 'black',
        };
        if (value == this.indexofModif) {
            styles = {
                'color': 'purple',
            };
        }
        return styles;
    }

    AddSupplier(): void {
        var index = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === this.supplier_selected.id_supplier);
        if (index > -1) {

        }
        else { // NOUVEAU
            if (!isNaN(Number(this.appro_min)) && this.appro_min != 0) {
                this.supplier_selected_list.push({supplier_object: this.supplier_selected, appro_min: this.appro_min});
                this.appro_min = 1;
                this.supplier_selected = this.supplier_list[0];
            }
        }
        if (this.supplier_selected_list.length == this.supplier_list.length) {
            this.disable_all_supplier_operation = true;
        }
        this.IsAvalable(this.supplier_list[0]);
    }

    MofidySupplierApproMin(): void {
        if (!isNaN(Number(this.appro_min)) && this.appro_min != 0) {
            var index = this.indexofModif;

            this.supplier_selected_list.splice(index, 1, {supplier_object: this.supplier_selected, appro_min: this.appro_min});
            this.appro_min = 1;
            this.operation_bt = "ajouter";
            this.disable_select_list = false;
            this.supplier_selected = this.supplier_list[0];

            if (this.supplier_selected_list.length == this.supplier_list.length) {
                this.disable_all_supplier_operation = true;
            }
            this.indexofModif = -1;
        }
    }

    IsAvalable(supplier_param: any): void {
        var index = this.supplier_selected_list.findIndex(supplier => supplier.supplier_object.id_supplier === supplier_param.id_supplier);
        if (index > -1) {
            this.disable_bt = true;
        } else {
            this.disable_bt = false;
        }
    }

    CheckUserSession(): void {
        this.authentification_service.UserCheckSession()
            .then(result => {
                if (result['id_user'] === 0) {
                    this.router.navigate(['authentification'])
                };
            });
    }

    CapacityZero(value: any) {
        if (Number(value) == 0) {
            return '-';
        } else {
            return value;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/products-list.component.ts